import { ENDPOINTS } from "../../apiConfig";
// import { showToast } from "../../../components";

import axiosRequest from "./axiosService";

// export const addDocumets = async ({
//   coll,
//   refColl,
//   refId,
//   refField,
//   refPatchId,
//   isRefFieldArray = true,
//   payload,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     console.log({
//       coll,
//       refColl,
//       refId,
//       refField,
//       refPatchId,
//       isRefFieldArray,
//       payload,
//     });

//     const response = await axios.post(
//       ENDPOINTS.UNIVERSAL.DOCUMENT_ADD,
//       {
//         coll,
//         refColl,
//         refId,
//         refField,
//         refPatchId,
//         isRefFieldArray,
//         payload,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     if (!response.data) {
//       throw new Error("Empty response from server");
//     }

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     return {
//       success: false,
//       error: error.response?.data?.message || "Failed to add document",
//     };
//   }
// };


export const addDocumets = async ({
  coll,
  refColl,
  refId,
  refField,
  refPatchId,
  parent,
  isRefFieldArray = true,
  payload,
}) => {
  // You can keep the console log outside or inside axiosRequest if you want
  console.log({
    coll,
    refColl,
    refId,
    refField,
    refPatchId,
    isRefFieldArray,
    payload,
  });

  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.UNIVERSAL.DOCUMENT_ADD,
    data: {
      coll,
      refColl,
      refId,
      refField,
      refPatchId,
      parent,
      isRefFieldArray,
      payload,
    },
  });
};